import React from 'react';
import styled from 'styled-components';
import { Portal } from '@lt/components';

import SubscriptionForm from './SubscriptionForm';

import type { PropsFromRedux as ISubscriptionFormWrapper } from '.';

const SubscriptionFormWrapper = (props: ISubscriptionFormWrapper) => {
  const { isMobile, isOpen } = props;

  return (
    <>
      {isMobile && isOpen && (
        <Portal>
          <MobileWrapper>
            <SubscriptionForm />
          </MobileWrapper>
        </Portal>
      )}

      {!isMobile && <SubscriptionForm />}
    </>
  );
};

const MobileWrapper = styled.div`
  z-index: 9999;
  position: fixed;
  overflow: hidden;
  inset: 0;
  background-color: #fff;
`;

export default SubscriptionFormWrapper;
